<div class="produtc-qa-container" *ngIf="showProductPanel" [ngStyle]="{'width':showProductPanel && !mobileView ? '50vw': '100vw'}">
    <div>
      <div class="product-qa-title-container" *ngIf="!mobileView">
        <span class="product-qa-title">{{ type === 'qna' ? 'Product Q&A' : 'Product Compare'}} </span>
        <mat-icon fontIcon="close" (click)="closePanel()" class="product-qa-close"></mat-icon>
      </div>
      <ng-container *ngIf="type==='qna'">
        <app-product-chat-description [selectedProduct]="selectedProduct"></app-product-chat-description>
      </ng-container>
      <ng-container *ngIf="type==='comparison'">
        <ng-container *ngFor="let product of selectedProducts; let i = index;">
          <app-product-chat-description [selectedProduct]="product"></app-product-chat-description>
        </ng-container>
      </ng-container>
      <div class="product-qa-divider" *ngIf="!mobileView">
        <hr class="product-qa-divider-line">
      </div>
    </div>
    <div class="product-message-content">
      <div class="product-chat-box">
        <ng-container *ngFor="let message of productMessages; let i = index">
          <div class="message user" *ngIf="message.sender === 'user'">
            <div class="message-text" [innerHTML]="getSafeHTML(message.text)"></div>
          </div>
          <div *ngIf="message.sender === 'bot'" class="bot-container">
            <div class="bot-icon">
              <img src="../../../assets/SMG-logo.png" alt="" height="29" width="29">
            </div>
            <div>
              <div class="message bot">
                <div class="message-text" [innerHTML]="getSafeHTML(message.text)"></div>
              </div>
              <ng-container>
                <app-feedback [message]="message" [uniqueConversationId]="childUniqueConversationId"></app-feedback>
              </ng-container>
            </div>
          </div>
        </ng-container>
        @if (productConversationLoading) {
          <app-loader></app-loader>
        }
        <div class="product-qa-suggestion-container" *ngIf="productMessages.length > 0">
          <ng-container *ngFor="let suggestion of suggestions; let i = index">
            <button class="product-qa-suggestions" (click)="sendSuggestion(suggestion)" [disabled]="productConversationLoading">{{ suggestion }}</button>
          </ng-container>
        </div>
      </div>
    </div>
    <div class="message-input-container">
      <div class="message-input-box-container">
        <input type="text" class="message-input-box" id="message-input-box-qa" placeholder="Ask me anything..." [(ngModel)]="userInputProductQA" (keydown.enter)="sendMessage()" autocomplete="off" [disabled]="productConversationLoading"/>
      </div>
      <div class="message-send-button-container">
        <button type="submit" class="send-button" (click)="sendMessage()" [disabled]="productConversationLoading">
          <span class="material-symbols-outlined">
            arrow_right_alt
        </span>
        </button>
      </div>
    </div>
  </div>